module.exports = __webpack_public_path__ + "static/US-CA-c745848aeca75f6d231851faaa6a3646.svg";